@if (rows().length) {
  <div class="flex flex-col gap-3">
    @for (row of rows(); track row.signer.id) {
      <div class="flex flex-wrap items-center gap-3 p-4 rounded-xl bg-white shadow">
        <p-button
          [label]="row.initials"
          severity="secondary"
          [outlined]="true"
          [rounded]="false"
          [raised]="false"
          [text]="false"
          [link]="false"
          size="small"
          styleClass="!rounded-full !w-9 !h-9 !p-0 shrink-0 !border-amber-200 !bg-amber-50 !text-amber-800"
          [attr.aria-hidden]="true"
          [tabindex]="-1"
        />

        <div class="flex flex-col gap-1 min-w-0">
          <div class="flex items-center gap-2 flex-wrap leading-none">
            <h5 class="m-0 text-body-600 text-surface-700 leading-none">
              {{ row.signer.signee?.name || row.roleLabel }}
            </h5>
            <p-tag [value]="row.roleLabel" size="small" severity="info" styleClass="uppercase" />
          </div>
          @if (row.signer.signee?.email; as email) {
            <a
              class="text-body-xs text-surface-500 no-underline hover:text-primary-500 transition-colors truncate"
              [href]="'mailto:' + email"
            >
              {{ email }}
            </a>
          }
          @if (row.signer.failureReason) {
            <span class="text-body-xs text-red-600">{{ row.signer.failureReason }}</span>
          }
        </div>

        <div class="flex items-center gap-2 ml-auto flex-wrap justify-end">
          <div class="flex flex-col items-end gap-1">
            @if (row.statusTag) {
              <p-tag
                [value]="row.statusTag.label"
                size="small"
                [severity]="row.statusTag.severity"
                styleClass="uppercase"
              />
            }
            @if (row.signedDate) {
              <span class="text-body-2xs text-surface-500 whitespace-nowrap">
                {{ row.signedDate | date: 'h:mm a, MM/dd/yyyy' }}
              </span>
            }
          </div>
          @if (row.canGetSignature) {
            <p-button
              label="Get Signature"
              size="small"
              [rounded]="true"
              [loading]="row.isPending"
              (onClick)="getSignature(row)"
            />
          }
          @if (row.canSendForSignature) {
            <p-button
              label="Send for Signature"
              size="small"
              [rounded]="true"
              [loading]="isBuilderRequestPending()"
              (onClick)="sendForSignature()"
            />
          }
          @if (row.canResend) {
            <p-button
              label="Resend Email"
              icon="pi pi-refresh"
              size="small"
              [rounded]="true"
              [outlined]="true"
              [loading]="row.isPending"
              (onClick)="resendEmail(row)"
            />
          }
        </div>
      </div>
    }
  </div>
} @else {
  <p class="m-0 text-body-sm text-surface-500">No signers on this envelope.</p>
}
